module.exports = __webpack_public_path__ + "img/radiateur_electrique.d2671c6.svg";